export default __webpack_public_path__ + "static/media/icon_3.61fa6f11.svg";